import { render, staticRenderFns } from "./setting-teams.vue?vue&type=template&id=a6890de6&scoped=true&"
import script from "./setting-teams.vue?vue&type=script&lang=js&"
export * from "./setting-teams.vue?vue&type=script&lang=js&"
import style0 from "./setting-teams.vue?vue&type=style&index=0&id=a6890de6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6890de6",
  null
  
)

export default component.exports